module.exports = __webpack_public_path__ + "static/media/domain.f34b4c98.svg";